export type HermesReadinessItem = {
  provider: string;
  mode: string;
  capabilities: Array<{ name: string; status: string }>;
};

export function hermesCodexConnectionRequired(items?: HermesReadinessItem[]) {
  const hermes = items?.find((item) => item.provider === "HERMES");
  if (!hermes || hermes.mode !== "LIVE") return false;
  const inference = hermes.capabilities.find((capability) => capability.name === "taskCreate");
  return !inference || !["CAPABILITY_TESTED", "ACCEPTANCE_TESTED", "PRODUCTION_VALIDATED"].includes(inference.status);
}
